import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { useLanguage, Language } from '../i18n';
export function LanguageSwitcher() {
  const {
    lang
  } = useLanguage();
  const location = useLocation();
  const getPath = (newLang: Language) => {
    const pathParts = location.pathname.split('/');
    pathParts[1] = newLang;
    return pathParts.join('/') || `/${newLang}`;
  };
  const languages: {
    code: Language;
    label: string;
  }[] = [{
    code: 'en',
    label: 'EN'
  }, {
    code: 'ua',
    label: 'UA'
  }, {
    code: 'ru',
    label: 'RU'
  }, {
    code: 'ro',
    label: 'RO'
  }];
  return <div className="flex items-center gap-1.5 sm:gap-2 text-sm font-medium" data-id="element-471" data-mp="e73gi4umsnty">
      <Globe className="w-4 h-4 text-charcoal-light hidden sm:block" data-id="element-472" data-mp="i86zh07z6zze" />
      <div className="flex items-center bg-stone-200 rounded-lg p-0.5 sm:p-1" data-id="element-473" data-mp="ia02m5jdr22n">
        {languages.map(({
        code,
        label
      }) => <Link key={code} to={getPath(code)} className={`px-2 sm:px-3 py-1 text-xs sm:text-sm rounded-md transition-all ${lang === code ? 'bg-ivory text-forest-600 shadow-sm' : 'text-charcoal-light hover:text-forest-600'}`} data-id="element-474" data-mp="2cms3nqscpcj8">
            {label}
          </Link>)}
      </div>
    </div>;
}